let globals = {
  trackingVersion: 'v2',
}

export const getGlobals = () => globals

export const setGlobals = (newWizardGlobals) => {
  globals = Object.assign({}, globals, newWizardGlobals)

  return globals
}
